import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["checked", "onClick"];
let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10;
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import styledWithTheme, { css } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const previewCardTheme = {
  AVATAR_SIZE: 30,
  ICON_SIZE: 14,
  FONT_SIZE: 12,
  DEFAULT_WEIGHT: 400,
  DEMI_BOLD: 500,
  BOLD: 600,
  BOLDEST: 700,
  HEIGHT: '106px',
  LEFT_SIDEBAR_WIDTH: '30px'
};
export const PreviewCardLeftSidebar = styledWithTheme.div(_t || (_t = _`
  display: flex;
  flex: 0 0;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: ${0};
  margin-right: 9px;
`), previewCardTheme.LEFT_SIDEBAR_WIDTH);
export const PreviewCardBody = styledWithTheme.div(_t2 || (_t2 = _`
  width: 100%;
`));
export const PreviewCardSourceIconWrapper = styledWithTheme.div(_t3 || (_t3 = _`
  display: flex;
  align-items: center;
  margin-left: 6px;
  max-width: ${0}px;
`), previewCardTheme.ICON_SIZE);
export const PreviewCardNameWrapper = styledWithTheme.span(_t4 || (_t4 = _`
  ${0}

  ${0}
`), ({
  isUnread
}) => isUnread && css(["font-weight:", ";font-size:16px;color:", ";"], previewCardTheme.BOLDEST, ({
  theme
}) => theme.color['text-core-default']), ({
  isUnknownContact
}) => isUnknownContact && css(["font-size:16px;color:", ";"], ({
  theme
}) => theme.color['icon-core-subtle']));
export const PreviewCardHeaderWrapper = styledWithTheme.div(_t5 || (_t5 = _`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 4px;
  font-size: 16px;
  line-height: 22px;
  color: ${0};
  padding-left: 6px;

  ${0}
`), ({
  theme
}) => theme.color['text-core-default'], ({
  isUnread
}) => css(["font-weight:", " !important;"], isUnread ? previewCardTheme.BOLDEST : previewCardTheme.DEFAULT_WEIGHT));
export const PreviewCardContentWrapper = styledWithTheme.div(_t6 || (_t6 = _`
  display: flex;
  flex-direction: column;
  width: 100%;
  color: ${0};
  margin-top: 6px;
`), ({
  theme
}) => theme.color['text-core-default']);
export const PreviewCardContentTextWrapper = styledWithTheme.div(_t7 || (_t7 = _`
  word-break: break-word;
  font-weight: ${0};
  font-size: 14px;
  line-height: 24px;
  max-width: 100%;
  padding-left: 6px;

  ${0};

  ${0};

  ${0};
`), previewCardTheme.DEFAULT_WEIGHT, ({
  isComment
}) => isComment && css(["border-radius:12px;background-color:", ";padding:0px 6px 0px 6px;"], ({
  theme
}) => theme.color['do-not-use-chart-yellow']), ({
  hasSLA
}) => hasSLA && css(["max-width:90%;margin-right:30px;"]), ({
  hasNoConversation
}) => hasNoConversation && css(["color:", ";"], ({
  theme
}) => theme.color['icon-core-subtle']));
export const PreviewCardContentHeaderWrapper = styledWithTheme.div(_t8 || (_t8 = _`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-bottom: 4px;
  font-weight: ${0};
  font-size: 15px;
  line-height: 20px;
  padding-left: 6px;

  ${0}

  ${0}
`), previewCardTheme.DEFAULT_WEIGHT, ({
  isUnread
}) => isUnread && css(["font-weight:", ";"], previewCardTheme.BOLD), ({
  isUnknownContact
}) => isUnknownContact && css(["color:", ";"], ({
  theme
}) => theme.color['icon-core-subtle']));
export const PreviewCardCheckboxWrapper = styledWithTheme.div(_t9 || (_t9 = _`
  margin: 5px;
  ${0}
`), ({
  checked
}) => checked && `
      &&& {
        display: block !important;
      }
    `);
export const PreviewCardCheckbox = _ref => {
  let {
      checked,
      onClick
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(PreviewCardCheckboxWrapper, {
      checked: checked,
      children: /*#__PURE__*/_jsx(Checkbox, Object.assign({
        checked: checked,
        onClick: onClick
      }, props))
    })
  );
};
PreviewCardCheckbox.displayName = 'PreviewCardCheckbox';
export const PreviewCardWrapper = styledWithTheme.div(_t10 || (_t10 = _`
  background-color: ${0};
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  height: ${0};
  width: 100%;
  cursor: pointer;
  border-bottom: solid 1px ${0};
  border-left: solid 4px transparent;
  padding: 12px 12px 12px 8px;

  ${0} {
    display: none !important;
  }

  #preview-card-channel-icon {
    display: block !important;
  }

  &:hover {
    ${0} {
      display: ${0} !important;
    }

    #preview-card-channel-icon {
      display: ${0} !important;
    }

    ${0} > * {
      color: ${0} !important;
    }
  }

  &:hover,
  &:focus {
    background-color: ${0} !important;
  }

  ${0}

  ${0}

  ${0}
`), ({
  theme
}) => theme.color['fill-surface-default'], previewCardTheme.HEIGHT, ({
  theme
}) => theme.color['border-core-subtle'], PreviewCardCheckboxWrapper, PreviewCardCheckboxWrapper, ({
  disabled
}) => disabled ? 'none' : 'block', ({
  hideBulkSelectCheckbox
}) => hideBulkSelectCheckbox ? 'block' : 'none', PreviewCardLeftSidebar, ({
  theme
}) => theme.color['icon-core-subtle'], ({
  theme
}) => theme.color['fill-field-hover'], ({
  disabled
}) => disabled && css(["&&{color:", ";cursor:not-allowed;opacity:0.25;}"], ({
  theme
}) => theme.color['icon-primary-disabled']), ({
  isSelected
}) => isSelected && css(["&&&{background-color:", " !important;border-left-color:", ";}"], ({
  theme
}) => theme.color['fill-field-hover'], ({
  theme
}) => theme.color['icon-interactive-default']), ({
  isUnread
}) => !isUnread && css(["&&{background-color:", ";}"], ({
  theme
}) => theme.color['fill-field-default']));